import React from "react";
import { withTranslation } from "react-i18next";
import { Grid, Typography } from "@mui/material";
import PropTypes from "prop-types";

import SelectField from "./Common/SelectField";
import InputFieldText from "./Common/InputFieldText";

const labelStyle = {
  maxWidth: "86%",
  textOverflow: "ellipsis",
  overflow: "hidden",
};

const RenderFields = ({ inputFields, parentKey, formik, t }) => (
  <Grid container columnSpacing={2}>
    {inputFields.map(
      ({ header, isRequired, options, label, name, InputProps, ...rest }) => {
        return header ? (
          <Grid item xs={12}>
            <Typography className="mb-3" lineHeight={1} variant="h6">
              {t(header)}
            </Typography>
          </Grid>
        ) : (
          <Grid key={name} item xs={12} sm={6} md={4}>
            {options ? (
              <SelectField
                formik={formik}
                label={isRequired ? t(label) + "*" : t(label)}
                name={`${parentKey}.${name}`}
                options={options}
                InputProps={InputProps}
                {...rest}
              />
            ) : (
              <InputFieldText
                formik={formik}
                label={
                  <p style={InputProps ? labelStyle : {}}>
                    {t(label) + (isRequired ? "*" : "")}
                  </p>
                }
                name={`${parentKey}.${name}`}
                InputProps={InputProps}
                {...rest}
              />
            )}
          </Grid>
        );
      }
    )}
  </Grid>
);

RenderFields.propTypes = {
  inputFields: PropTypes.array,
  parentKey: PropTypes.string,
  formik: PropTypes.object,
  t: PropTypes.bool,
};

export default withTranslation()(RenderFields);
